import "./Order.scss";
import { FaCheck, FaSearch } from "react-icons/fa";
import DatePicker, { getAllDatesInRange } from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from "axios";
import { AllOrders, date } from "../../services/Orders";
import { connection } from "../../services/services";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Cookie from "js-cookie";
import Loader from "utilities/Loader";
import { sendRequest } from "../../utilities/useAxios";

import { showSwalError, showSwalSuccess } from "../../utilities/swal";
import Box from "../../common/Box";
export default function Orders() {
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [TureFactors, setTureFactors] = useState([]);
  const [Total, setTotal] = useState(0);
  const [key, setKey] = useState(true);

  const date = (TimeStamp) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
      "fa-IR",
      options
    );
    date.replace(/([۰-۹])/g, (token) =>
      String.fromCharCode(token.charCodeAt(0) - 1728)
    );
    return date;
  };

  useEffect(async () => {
    let res = await connection("getmyfactors", {});
    setTureFactors(res.res);
    res.res && setLoading(false);
    res.res.map((item) => {
      setTotal(
        Total +
          parseInt(item.total_amt) -
          parseInt(item.total_discount + item.total_paid)
      );
    });
  }, [key]);

  const [info, setInfo] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    code: "",
  });

  const [passangers, setPassangers] = useState([]);

  const addPassanger = (passanger) => {
    setPassangers([...passangers, passanger]);
  };

  const add = (info, tour_id, factor_id) => {
    if (
      ["firstname", "lastname", "code", "phone"].reduce((prevVal, value) => {
        if (prevVal) return prevVal;
        if (info[value] == "") return true;
      }, false)
    ) {
      Swal.fire({
        title: "لطفا نام، نام خانوادگی، کدملی و شماره تماس را وارد کنید.",
        icon: "error",
      });
      return;
    }
    if (!/^(\+98|0)?9\d{9}$/.test(info.phone)) {
      Swal.fire({
        title: "لطفا شماره تماس را به درستی وارد کنید.",
        icon: "error",
      });
      return;
    }
    if (!/^\d{10}$/.test(info.code)) {
      Swal.fire({
        title: "لطفا کد ملی را به درستی وارد کنید.",
        icon: "error",
      });
      return;
    }

    let form = new FormData();
    form.append("mobile", `${info.phone}`);
    form.append("fname", `${info.firstname}`);
    form.append("lname", `${info.lastname}`);
    form.append("codemelli", `${info.code}`);
    form.append("factor_id", `${factor_id}`);
    form.append("tour_id", `${tour_id}`);
    form.append("mytoken", Cookie.get("token"));

    sendRequest("addhamsafar", form)
      .then(({ data }) => {
        if (data.state == 1) {
          setKey(!key);
          showSwalSuccess("همراه اضافه شد");
        } else {
          showSwalError("\n مشکلی پیش آمده لطفا دوباره امتحان کنید");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const Completion = (item) => {
    let form = new FormData();
    form.append("factor_id", `${item.id}`);
    form.append(
      "pay_amount",
      `${
        parseInt(item.total_amt) -
        parseInt(item.total_discount + item.total_paid)
      }`
    );
    form.append("callback", "customer-panel/Orders");
    sendRequest("payfactor", form)
      .then(({ data }) => {
        if (data.state == 1) {
          window.location.href = `${data.data.url}`;
        } else {
          showSwalError("\n مشکلی به وجود آمده لطفا دوباره امتحان کنید");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="border  w-100 mx-3 Orders bg-white mb-2">
        {loading ? <Loader /> : ""}

        {/* <div
            className="card shadow mx-auto my-3"
            style={{ width: "95%", borderRadius: "10px" }}
          >
            <div className="card-header bg-white py-4 mb-3 border-bottom-3 border-dark mx-3">
              <FaSearch className="mx-2" />
              جستجوی فاکتو
            </div>
            <div className="card-body d-flex flex-row p-0 pb-5">
              <div className=" mx-3">
                <label className="form-label" for="factor">
                  شماره فاکتور
                </label>
                <input className="form-control" id="factor" />
              </div>
              <div className=" mx-3 d-flex flex-column">
                <label className="form-label" for="date">
                  محدوده تاریخی
                </label>
                <DatePicker
                  id="date"
                  mainPosition="bottom"
                  fixMainPosition={true}
                  style={{ height: "38px", width: "100%" }}
                  value={value}
                  onChange={setValue}
                  calendar={persian}
                  locale={persian_fa}
                  range
                  plugins={[<DatePanel />]}
                />
              </div>
            </div>
          </div> */}

        {TureFactors &&
          TureFactors.map((item, index) => (
            <>
              {item.type == 0 && item.tour_info.length != 0 ? (
                <div
                  key={index}
                  className="card m-3 mx-auto shadow "
                  style={{ borderRadius: "10px", width: "95%" }}
                >
                  <div className="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom">
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusR-class"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>شماره فاکتور</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>{item.id}</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class2"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نوع سفارش</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>تور</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class3"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نام تور</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>{item.tour_info[0].title}</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class4"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تاریخ</span>
                      </div>
                      <div className="px-3 py-3">
                        <span> {date(item.mtm)} </span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class5 "
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>
                          مبلغ کل ( <small>تومان</small> )
                        </span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-success"> {item.total_amt} </span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class6 "
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>
                          مبلغ قابل پرداخت ( <small>تومان</small> )
                        </span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-success">
                          {" "}
                          {parseInt(item.total_amt) -
                            parseInt(
                              item.total_discount + item.total_paid
                            )}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class7 "
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تخفیف</span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-danger">
                          {" "}
                          {item.total_discount}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>عملیات</span>
                      </div>
                      <div
                        className="px-3 py-2 d-flex flex-row mx-auto"
                        style={{ width: "fit-content" }}
                      >
                        <button
                          className="btn text-white font-class"
                          style={{ backgroundColor: "#457B9D" }}
                          data-bs-target="#add-passanger-modal2"
                          data-bs-toggle="modal"
                        >
                          افزودن همراه
                        </button>
                        {parseInt(item.total_amt) -
                          parseInt(item.total_discount + item.total_paid) !=
                        0 ? (
                          <button
                            className="btn mx-1 text-white font-class"
                            style={{ backgroundColor: "#668CD9" }}
                            onClick={() => Completion(item)}
                          >
                            تکمیل وجه
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="text-center">
                                      <div className="py-2 fs-5">وضعیت</div>
                                      <div>
                                        <div className="container d-flex justify-content-center align-items-center my-5">
                                          <div className="progresses">
                                            <div className="steps position-relative">
                                              {" "}
                                              <span
                                                className="position-absolute font-class"
                                                style={{ top: "-25px", width: "100px" }}
                                              >
                                                اجرا شده
                                              </span>{" "}
                                              <span className="font-weight-bold text-white">
                                                {item.main_status >= 5 ? <FaCheck /> : 5}{" "}
                                              </span>
                                            </div>{" "}
                                            <span className="line"></span>
                                            <div className="steps position-relative">
                                              {" "}
                                              <span
                                                className="position-absolute font-class"
                                                style={{ top: "-25px", width: "100px" }}
                                              >
                                                درحال اجرا
                                              </span>{" "}
                                              <span className="font-weight-bold text-white">
                                                {item.main_status >= 4 ? <FaCheck /> : 4}{" "}
                                              </span>
                                            </div>{" "}
                                            <span className="line"></span>
                                            <div className="steps position-relative">
                                              {" "}
                                              <span
                                                className="position-absolute font-class"
                                                style={{ top: "-25px", width: "100px" }}
                                              >
                                                در انتظار اجرا
                                              </span>{" "}
                                              <span className="font-weight-bold text-white">
                                                {item.main_status >= 3 ? <FaCheck /> : 3}{" "}
                                              </span>
                                            </div>{" "}
                                            <span className="line"></span>
                                            <div className="steps position-relative">
                                              {" "}
                                              <span
                                                className="position-absolute font-class"
                                                style={{ top: "-25px", width: "100px" }}
                                              >
                                                ثبت نام
                                              </span>{" "}
                                              <span className="font-weight-bold text-white">
                                                {item.main_status <= 2 ? <FaCheck /> : 2}{" "}
                                              </span>
                                            </div>{" "}
                                            <span className="line"></span>
                                            <div className="steps position-relative">
                                              {" "}
                                              <span
                                                className="position-absolute font-class"
                                                style={{ top: "-25px", width: "100px" }}
                                              >
                                                پیش ثبت نام
                                              </span>{" "}
                                              <span className="font-weight-bold text-white">
                                                {item.main_status >= 1 ? <FaCheck /> : 1}{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                </div>
              ) : item.type == 1 && item.tour_info.length != 0 ? (
                <div
                  key={index}
                  className="card m-3 mx-auto shadow"
                  style={{ borderRadius: "10px", width: "95%" }}
                >
                  <div className="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom ">
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusR-class"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>شماره فاکتور</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>111134</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class21"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نام کالا</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>چای سبز</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class31"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تعداد</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>سه عدد</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class41"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تاریخ و ساعت سفارش</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>399/2/2 18:22</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class51"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تاریخ تحویل</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>1399/3/2</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class61"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>
                          مبلغ ( <small>تومان</small> )
                        </span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-success">350000</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class11 rediusL-class1 "
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تخفیف</span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-danger">350000</span>
                      </div>
                    </div>
                  </div>

                  {/* <div className="text-center">
                    <div className="py-2 fs-5">وضعیت</div>
                    <div>
                      <div className="container d-flex justify-content-center align-items-center my-5">
                        <div className="progresses">
                          <div className="steps2 position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              ارسال شده
                            </span>{" "}
                            <span className="font-weight-bold text-white">4</span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps2 position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              لغو شده
                            </span>{" "}
                            <span className="font-weight-bold text-white">3</span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps2 position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              درحال ارسال
                            </span>{" "}
                            <span className="font-weight-bold text-white">
                              <FaCheck />
                            </span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps2 position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              در حال پردازش
                            </span>{" "}
                            <span className="font-weight-bold text-white">
                              <FaCheck />
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              ) : item.type == 1 && item.tour_info.length != 0 ? (
                <div
                  key={index}
                  className="card m-3 mx-auto shadow"
                  style={{ borderRadius: "10px", width: "95%" }}
                >
                  <div className="card-body d-flex flex-row flex-wrap p-0 text-center border-bottom ">
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusR-class"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>شماره فاکتور</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>111134</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class22"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نوع سفارش</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>بلیط هواپیما</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class32"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نام شرکت هواپیمایی</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>ایران ایر</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class42"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>مبدا</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>گرگان</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class52"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>مقصد</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>تهران</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class62"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تاریخ و ساعت</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>1399/2/2 18:22</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class72"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>نام فرودگاه</span>
                      </div>
                      <div className="px-3 py-3">
                        <span>امام</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className=" px-3  py-3 rediusL-class82"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>
                          مبلغ ( <small>تومان</small> )
                        </span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-success">350000</span>
                      </div>
                    </div>
                    <div className="flex-fill">
                      <div
                        className="px-3  py-3 rediusL-class92"
                        style={{ backgroundColor: "#D6EEEB" }}
                      >
                        <span>تخفیف</span>
                      </div>
                      <div className="px-3 py-3">
                        <span className="text-danger">0</span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="text-center">
                    <div className="py-2 fs-5">وضعیت</div>
                    <div>
                      <div className="container d-flex justify-content-center align-items-center my-5">
                        <div className="progresses">
                          <div className="steps position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              خرید
                            </span>{" "}
                            <span className="font-weight-bold text-white">5</span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              در حال خرید
                            </span>{" "}
                            <span className="font-weight-bold text-white">4</span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              بایگانی
                            </span>{" "}
                            <span className="font-weight-bold text-white">3</span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              لغو
                            </span>{" "}
                            <span className="font-weight-bold text-white">
                              <FaCheck />
                            </span>{" "}
                          </div>{" "}
                          <span className="line"></span>
                          <div className="steps position-relative">
                            {" "}
                            <span
                              className="position-absolute font-class"
                              style={{ top: "-25px", width: "100px" }}
                            >
                              رزرو
                            </span>{" "}
                            <span className="font-weight-bold text-white">
                              <FaCheck />
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              ) : null}

              {/* modall */}

              <div
                className="modal fade"
                id="add-passanger-modal2"
                tabindex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg modal-dialog-centered the-modal1">
                  <div className="modal-content">
                    <div className="modal-header border-0">افزودن همراه</div>
                    <div
                      className="modal-body py-3 px-5"
                      style={{
                        minHeight: "400px",
                        maxHeight: "400px",
                        overflow: "auto",
                      }}
                    >
                      <form>
                        <div className="row justify-content-between">
                          <label
                            htmlFor="firstname"
                            className="mb-3 col-12 col-sm-6 col-lg-2 col-form-label the-required"
                          >
                            نام
                          </label>
                          <div className="mb-3 col-12 col-sm-6 col-lg-10">
                            <input
                              type="text"
                              className="form-control"
                              id="firstname"
                              value={info.firstname}
                              onChange={(e) =>
                                setInfo({
                                  ...info,
                                  firstname: e.target.value,
                                })
                              }
                            />
                          </div>
                          <br></br>
                          <label
                            htmlFor="lastname"
                            className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label the-required"
                          >
                            نام خانوادگی
                          </label>
                          <div className="mb-3 col-12 col-sm-6 col-lg-10">
                            <input
                              type="text"
                              className="form-control"
                              id="lastname"
                              value={info.lastname}
                              onChange={(e) =>
                                setInfo({ ...info, lastname: e.target.value })
                              }
                            />
                          </div>
                          <label
                            htmlFor="code"
                            className="mb-3 col-12 col-sm-4 col-lg-1 col-form-label the-required"
                          >
                            کدملی
                          </label>
                          <div className="mb-3 col-12 col-sm-6 col-lg-10">
                            <input
                              type="number"
                              className="form-control"
                              id="code"
                              value={info.code}
                              onChange={(e) =>
                                setInfo({ ...info, code: e.target.value })
                              }
                            />
                          </div>
                          <label
                            htmlFor="phone"
                            className="mb-3 col-12 col-sm-4 col-lg-2 col-form-label the-required"
                          >
                            شماره تماس
                          </label>
                          <div className="mb-3 col-12 col-sm-6 col-lg-10">
                            <input
                              type="number"
                              className="form-control"
                              id="phone"
                              value={info.phone}
                              onChange={(e) =>
                                setInfo({ ...info, phone: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="row">
                          </div> */}
                      </form>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="col-12 col-sm-5 col-lg-3 btn btn-primary the-btn"
                          // data-bs-dismiss={dismiss}
                          onClick={() =>
                            add(info, item.tour_info[0].id, item.id)
                          }
                        >
                          ثبت
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}

        <div
          className="mx-auto text-center p-3 my-4 rounded-3"
          style={{ width: "fit-content", backgroundColor: "#D6EEEB" }}
        >
          مبلغ کل سفارشات
          <span className="mx-3">{Total}</span>
        </div>
      </div>
    </>
  );
}
